import React, { useState } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { getSectionNavMediumColor } from 'styles/helpers/getThemeStyles';
import { MEDIUM_TOFU } from 'styles/theme/colors';

const StyledInput = styled('input')(({ theme }) => {
  return {
    width: '32px',
    height: '42px',
    textAlign: 'center',
    outline: 'none',
    inputMode: 'numeric',
    pattern: '[0-9]*',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    border: `solid ${MEDIUM_TOFU}`,
    borderRadius: '3px',
    fontSize: '16px',
    color: getSectionNavMediumColor(theme),
    backgroundColor: theme?.palette?.page?.background?.main,
    ...theme?.typography?.menuItemNames
  };
});

const QuantityContainer = styled('div')({
  paddingTop: '1px',
  paddingRight: '1rem'
});

const CartItemQuantity = ({ item, updateQuantity }) => {
  const [quantity, setQuantity] = useState(item.quantity);
  const updateCartItemQuantity = debounce(item => {
    updateQuantity(item, quantity);
  }, 500);

  const cleanInput = val => (val !== '' && val <= 0 ? null : setQuantity(val));
  return (
    <QuantityContainer>
      <StyledInput
        type="number"
        value={quantity}
        onChange={e => cleanInput(e.target.value)}
        onBlur={() =>
          item.quantity !== quantity && updateCartItemQuantity(item, quantity)
        }
        data-testid="quantity-value"
        aria-label="Quantity Input"
        onKeyPress={e => {
          if (e.key === 'e' || isNaN(parseInt(e.key))) {
            e.preventDefault();
          }
        }}
      />
    </QuantityContainer>
  );
};

CartItemQuantity.propTypes = {
  item: PropTypes.shape({
    quantity: PropTypes.number,
    name: PropTypes.string,
    variant: PropTypes.shape({
      price: PropTypes.string,
      name: PropTypes.string
    }),
    order_made_for: PropTypes.string,
    special_instructions: PropTypes.string,
    required_fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string
      })
    )
  }),
  updateQuantity: PropTypes.func.isRequired
};

export default CartItemQuantity;
